export const HIDE_CLIENT_FIRST_RECOMMENDATION_TOOLTIP =
  'HIDE_CLIENT_FIRST_RECOMMENDATION_TOOLTIP';

export const HIDE_CONTRACTOR_FIRST_RECOMMENDATION_TOOLTIP =
  'HIDE_CONTRACTOR_FIRST_RECOMMENDATION_TOOLTIP';
